/* eslint-disable*/
import theme from 'theme';
import Clear from '@mui/icons-material/Clear';

const NGicon = ({ sx = {} }) => {
  return (
    <Clear
      sx={{
        color: '#FFC100',
        fontSize: '32px',
        fontWeight: 'bold',
        mr: 1,
        ...sx // 追加のスタイルを上書き可能に
      }}
    />
  );
};

export default NGicon;
